<template>
  <StackLayout class="wrapper" role="dialog" aria-modal="true">
    <AgCard modal :caption="caption">
      <StackLayout class="card-content">
        <DatePicker 
          class="input" 
          :date="date" 
          role="datepicker"
          :aria-label="'Datum auswählen: ' + caption"
          @dateChange="change" 
          @loaded="loaded" 
        />
        <FlexboxLayout class="actions" justifyContent="center" role="group" aria-label="Aktionen">
          <AgButton outlined icon="times" @tap="cancel" @click="cancel" aria-label="Abbrechen" />
          <AgButton icon="check" @tap="done" @click="done" aria-label="Bestätigen" />
        </FlexboxLayout>
      </StackLayout>
    </AgCard>
  </StackLayout>
</template>

<script>

import env from '@/helpers/env'

const now = new Date()

export default {
  props: {
    caption: {
      type: String
    },
    date: {
      default: now
    }
  },
  data() {
    return {
      dateReal: null
    }
  },
  watch: {
    date: {
      immediate: true,
      handler (to) {
        this.dateReal = to
      }
    }
  },
  methods: {
    change (event) {
      this.dateReal = event.value
    },
    done () {
      this.$emit('done', this.dateReal)
    },
    cancel () {
      this.$emit('done')
    },
    loaded (view) {
      if (env.isIos && env.system.osVersion.split('.')[0] >= 14) {
        view.object.ios.preferredDatePickerStyle = 1
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.ns-ios,
.ns-android {
  .wrapper .actions > * {
    margin: 0 10 0 10;
  }
}

html {
  .wrapper .actions > * {
    margin: 0 10px 0 10px;
  }
}

</style>